export const IMAGE_UPLOAD_BUTTON_TYPE = {
  DEFAULT: 'default',
  ICON: 'icon',
};

export const ASPECT_RATIO_TOLERANCE = 0.05;
